export {validateEmail} from "exports-loader?exports=validateEmail!common";
export {parseBool} from "exports-loader?exports=parseBool!common";
export {getHumanFileSize} from "exports-loader?exports=getHumanFileSize!common";

export const filterObject = (source, ...names) => {
	return names.reduce((result, name) => {
		let p = name.split(':');
		let from = p.shift();
		let to = p.shift() || from;
		if(typeof source[from] !== 'undefined') {
			result[to] = source[from];
		}
		return result;
	}, {});
};

export const parseInputFile = (file) => {
	return {
		toBase64: callback => {
			if (window.FileReader) {
				let reader = new FileReader();
				const onLoad = ({target}) => callback(target.result);

				if (reader.addEventListener) {
					reader.addEventListener('load', onLoad, false);
				} else {
					reader.onload = onLoad;
				}
				reader.readAsDataURL(file);
			}
		},
		getSize: () => file.size,
		getMimeType: () => file.type,
		getName: () => file.name
	};
};

export const ucFirst = (text) => {
    return text.substring(0, 1).toUpperCase() + text.substring(1).toLowerCase();
}

export default {
	filterObject,
	parseInputFile
};
